import { Col, Dropdown, Button, Image } from 'react-bootstrap'
import Chart from 'react-apexcharts'
import Card from '../common/Card'
import CustomToggle from '../../layouts/components/CustomToggle'
import { useChart } from '../../utils/chart-hook'
import { logos } from '../../utils/platform-logos'
import { CalendarIcon, ChevronDownIcon } from '../icons/new'

const PlatformAudienceChart = ({ name, data, audience }) => {
    data = data.map((obj) => ({
        ...obj,
        ...audience[obj.name],
    }))

    const { series, options, currentPeriod, currentPlatform, changePeriod, changePlatform } = useChart(
        'bar',
        data,
        ['audienceThisWeek', 'audienceThisMonth', 'audienceThisYear'],
        'Audience',
        { colors: ['#08B1BA'] },
    )

    return (
        <Col md={12} xl={7}>
            <Card data-aos="fade-up" data-aos-delay="1000" className="dashboard-step-4 tw:!rounded-xs">
                <div className="flex-wrap card-header d-flex justify-content-between">
                    <div className="header-title">
                        <h6 className="title text-white mb-0">
                            {name} - {currentPlatform}{' '}
                            <Button variant="sm social-btn rounded-circle p-1 mx-1 no-pointer">
                                <Image
                                    src={logos[currentPlatform]}
                                    alt={currentPlatform}
                                    className="img-fluid object-contain"
                                    style={{ width: '20px', height: '20px' }}
                                />
                            </Button>
                        </h6>
                    </div>
                    <div className="d-flex flex-row">
                        <Dropdown className="mr-1">
                            <Dropdown.Toggle
                                as={CustomToggle}
                                href="#"
                                variant=" text-secondary"
                                id="dropdownMenuPlatform"
                                aria-expanded="false"
                                className="tw:!rounded-xs"
                            >
                                <div className="d-flex align-items-center">
                                    <span className="text-sm text-blue-300 mb-0">Select Platform</span>
                                    <ChevronDownIcon size={20} className="me-1 text-blue-300" />
                                </div>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="dropdown-menu-end" aria-labelledby="dropdownMenuPeriod">
                                {data.map((platform) => {
                                    return (
                                        <li key={platform.id} className="d-flex mt-1 align-items-center">
                                            <Dropdown.Item href="#" onClick={() => changePlatform(platform.id)}>
                                                <Button
                                                    variant="sm social-btn rounded-circle no-pointer mx-1"
                                                    style={{ width: '20px', height: '20px', padding: '0 0.25rem' }}
                                                >
                                                    <Image
                                                        src={logos[platform.name]}
                                                        alt={platform.name}
                                                        className="img-fluid object-contain"
                                                        style={{ width: '10px', height: '10px' }}
                                                    />
                                                </Button>{' '}
                                                {platform.name}
                                            </Dropdown.Item>
                                        </li>
                                    )
                                })}
                            </Dropdown.Menu>
                        </Dropdown>
                        <Dropdown>
                            <Dropdown.Toggle
                                as={CustomToggle}
                                href="#"
                                variant=" text-secondary"
                                id="dropdownMenuButton3"
                                aria-expanded="false"
                            >
                                <div className="d-flex align-items-center">
                                    <CalendarIcon size={20} className="text-blue-300 me-1" />
                                    <span className="text-sm text-blue-300">{currentPeriod}</span>
                                </div>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="dropdown-menu-end" aria-labelledby="dropdownMenuButton3">
                                <li>
                                    <Dropdown.Item href="#" onClick={() => changePeriod('week')}>
                                        <span className="tw:!text-sm">This Week</span>
                                    </Dropdown.Item>
                                </li>
                                <li>
                                    <Dropdown.Item href="#" onClick={() => changePeriod('month')}>
                                        <span className="tw:!text-sm">This Month</span>
                                    </Dropdown.Item>
                                </li>
                                <li>
                                    <Dropdown.Item href="#" onClick={() => changePeriod('year')}>
                                        <span className="tw:!text-sm">This Year</span>
                                    </Dropdown.Item>
                                </li>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
                <Card.Body>
                    <Chart className="d-activity" options={options} series={series} type="bar" height="300" />
                </Card.Body>
            </Card>
        </Col>
    )
}

export default PlatformAudienceChart
